import React, { useState, useEffect } from 'react';
import api from '../api';

const FORM_INICIAL = {
  nome: '', fatias: '', tipo: 'imediato',
  forma_tamanho: '', cakeboard_tamanho: '', massa_crua_por_forma: '',
  discos_por_forma: '2',
  discos_camadas: '', discos_gramas: '',
  calda_camadas: '', calda_gramas: '',
  cinta_camadas: '', cinta_gramas: '',
  cobertura_camadas: '', cobertura_gramas: '',
  recheio_camadas: '3',
};

function gerarPares(lista) {
  const pares = [];
  for (let i = 0; i < lista.length; i++)
    for (let j = i + 1; j < lista.length; j++)
      pares.push({ a: lista[i], b: lista[j] });
  return pares;
}

function Progresso({ step, total }) {
  const labels = ['Dados básicos', 'Massas', 'Recheios', 'Combinações'];
  return (
    <div className="flex items-center gap-1 mb-6">
      {Array.from({ length: total }, (_, i) => i + 1).map((s, i) => (
        <React.Fragment key={s}>
          <div className="flex items-center gap-1.5 min-w-0">
            <div className={`w-7 h-7 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-bold transition-colors ${
              step > s ? 'bg-green-500 text-white' :
              step === s ? 'bg-pink-600 text-white' :
              'bg-gray-100 text-gray-400'
            }`}>
              {step > s ? '✓' : s}
            </div>
            <span className={`text-xs font-medium hidden sm:block truncate ${step === s ? 'text-pink-600' : 'text-gray-400'}`}>
              {labels[s - 1]}
            </span>
          </div>
          {i < total - 1 && (
            <div className={`flex-1 h-0.5 min-w-4 rounded ${step > s ? 'bg-green-400' : 'bg-gray-100'}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default function GuiaTamanhos() {
  const [tamanhos, setTamanhos] = useState([]);
  const [fichasMassa, setFichasMassa] = useState([]);
  const [todasFichas, setTodasFichas] = useState([]);
  const [recheiosExistentes, setRecheiosExistentes] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const [wizardAberto, setWizardAberto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [step, setStep] = useState(1);
  const [salvando, setSalvando] = useState(false);
  const [salvarMsg, setSalvarMsg] = useState('');

  // Filtros da lista
  const [busca, setBusca] = useState('');
  const [tipoFiltro, setTipoFiltro] = useState('todos');

  // Step 1
  const [form, setForm] = useState(FORM_INICIAL);
  // Step 2
  const [massesSelecionadas, setMassesSelecionadas] = useState([]);
  // Step 3 — lista de { id, tempId, nome, isNew, base_tipo, base_ficha_id, base_produto_id,
  //                      tem_complemento, complemento_tipo, complemento_ficha_id, complemento_produto_id,
  //                      gramas_base, gramas_complemento }
  const [recheiosSelecionados, setRecheiosSelecionados] = useState([]);
  // Step 4 — lista de { key, nomeA, nomeB, keyA, keyB, camadas_a, camadas_b, nome }
  const [combinacoes, setCombinacoes] = useState([]);
  const [combsRegistradas, setCombsRegistradas] = useState([]);

  useEffect(() => { carregarDados(); }, []);

  async function carregarDados() {
    setLoading(true);
    try {
      const [resTam, resFichas, resRecheios, resProd, resCombsReg] = await Promise.all([
        api.get('/guia/tamanhos'),
        api.get('/fichas/api/fichas-tecnicas'),
        api.get('/guia/recheios'),
        api.get('/produtos'),
        api.get('/guia/combinacoes'),
      ]);
      setTamanhos(resTam.data);
      const lista = resFichas.data?.fichas || [];
      setFichasMassa(lista.filter(f => f.categoria === 'Massas de Bolo'));
      setTodasFichas(lista);
      setRecheiosExistentes(resRecheios.data || []);
      setProdutos(resProd.data || []);
      setCombsRegistradas(resCombsReg.data || []);
    } catch {
      setErro('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  }

  // ── Abrir wizard ─────────────────────────────────────────────────────────────
  function abrirNovo() {
    setForm(FORM_INICIAL);
    setMassesSelecionadas([]);
    setRecheiosSelecionados([]);
    setCombinacoes([]);
    setEditando(null);
    setStep(1);
    setErro('');
    setWizardAberto(true);
  }

  function abrirEditar(t) {
    setForm({
      nome: t.nome, fatias: t.fatias, tipo: t.tipo,
      forma_tamanho: t.forma_tamanho || '',
      cakeboard_tamanho: t.cakeboard_tamanho || '',
      massa_crua_por_forma: t.massa_crua_por_forma,
      discos_por_forma: t.discos_por_forma ?? 2,
      discos_camadas: t.discos_camadas, discos_gramas: t.discos_gramas,
      calda_camadas: t.calda_camadas, calda_gramas: t.calda_gramas,
      cinta_camadas: t.cinta_camadas, cinta_gramas: t.cinta_gramas,
      cobertura_camadas: t.cobertura_camadas, cobertura_gramas: t.cobertura_gramas,
      recheio_camadas: t.recheio_camadas,
    });
    setMassesSelecionadas((t.massas_permitidas || []).map(m => m.ficha_tecnica_id));

    const recheiosDoTamanho = (t.recheios_permitidos || []).map(r => {
      const temCompl = !!(r.complemento_ficha_id || r.complemento_produto_id);
      return {
        id: r.recheio_id,
        tempId: null,
        nome: r.nome,
        isNew: false,
        tem_complemento: temCompl,
        gramas_base: r.gramas_base ?? '',
        gramas_complemento: r.gramas_complemento ?? '',
      };
    });
    setRecheiosSelecionados(recheiosDoTamanho);
    setCombinacoes([]);
    setEditando(t.id);
    setStep(1);
    setErro('');
    setWizardAberto(true);
  }

  function fecharWizard() { setWizardAberto(false); setErro(''); }

  // ── Step 1 ───────────────────────────────────────────────────────────────────
  function handleChange(e) {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
  }

  function step1Valido() {
    return form.nome && form.fatias && form.massa_crua_por_forma &&
      form.discos_camadas && form.discos_gramas &&
      form.calda_camadas && form.calda_gramas &&
      form.cinta_camadas && form.cinta_gramas &&
      form.cobertura_camadas && form.cobertura_gramas;
  }

  // ── Step 3 — recheios ────────────────────────────────────────────────────────
  function toggleRecheioExistente(r) {
    const jaEsta = recheiosSelecionados.find(x => x.id === r.id);
    if (jaEsta) {
      setRecheiosSelecionados(p => p.filter(x => x.id !== r.id));
    } else {
      const temCompl = !!(r.complemento_ficha_id || r.complemento_produto_id);
      setRecheiosSelecionados(p => [...p, {
        id: r.id, tempId: null, nome: r.nome, isNew: false,
        tem_complemento: temCompl,
        gramas_base: '', gramas_complemento: '',
      }]);
    }
  }

  function adicionarNovoRecheio() {
    setRecheiosSelecionados(p => [...p, {
      id: null, tempId: Date.now(), nome: '',
      isNew: true,
      base_tipo: 'ficha', base_ficha_id: '', base_produto_id: '',
      tem_complemento: false,
      complemento_tipo: 'ficha', complemento_ficha_id: '', complemento_produto_id: '',
      gramas_base: '', gramas_complemento: '',
    }]);
  }

  function chaveRecheio(r) { return r.id ?? r.tempId; }

  function atualizarRecheio(key, campo, valor) {
    setRecheiosSelecionados(p => p.map(r => {
      if (chaveRecheio(r) !== key) return r;
      const u = { ...r, [campo]: valor };
      if (campo === 'base_ficha_id' && valor && !u.nome) {
        const f = todasFichas.find(f => f.id === Number(valor));
        if (f) u.nome = f.nome;
      }
      return u;
    }));
  }

  function removerRecheio(key) {
    setRecheiosSelecionados(p => p.filter(r => chaveRecheio(r) !== key));
  }

  // ── Step 4 — combinações ─────────────────────────────────────────────────────
  function inicializarCombinacoes() {
    setCombinacoes(paresSemCombinacao.map(({ a, b }) => ({
      key: `${chaveRecheio(a)}_${chaveRecheio(b)}`,
      nomeA: a.nome, nomeB: b.nome,
      keyA: chaveRecheio(a), keyB: chaveRecheio(b),
      camadas_a: 2, camadas_b: 1,
      nome: `${a.nome} + ${b.nome}`,
    })));
  }

  function atualizarCombinacao(key, campo, valor) {
    setCombinacoes(p => p.map(c => {
      if (c.key !== key) return c;
      const u = { ...c, [campo]: Number(valor) };
      if (campo === 'camadas_a') u.camadas_b = Number(form.recheio_camadas) - Number(valor);
      return u;
    }));
  }

  // ── Navegação ────────────────────────────────────────────────────────────────
  const nCamadas = Number(form.recheio_camadas);
  const pares = gerarPares(recheiosSelecionados);
  const paresSemCombinacao = pares.filter(({ a, b }) => {
    const idA = a.id ?? null;
    const idB = b.id ?? null;
    if (!idA || !idB) return true; // recheios novos sempre precisam
    return !combsRegistradas.some(c =>
      (c.recheio_principal_id === idA && c.recheio_secundario_id === idB) ||
      (c.recheio_principal_id === idB && c.recheio_secundario_id === idA)
    );
  });
  const precisaCombinacoes = !editando && nCamadas === 3 && paresSemCombinacao.length > 0;
  const totalSteps = precisaCombinacoes ? 4 : 3;
  const isLastStep = step === totalSteps;

  function avancar() {
    if (step === 3 && precisaCombinacoes) inicializarCombinacoes();
    setStep(s => s + 1);
  }

  // ── Salvar ───────────────────────────────────────────────────────────────────
  async function salvar() {
    setSalvando(true);
    setSalvarMsg('Salvando tamanho...');
    setErro('');
    try {
      // 1. Tamanho
      const payloadTam = {
        ...form,
        fatias: Number(form.fatias),
        massa_crua_por_forma: Number(form.massa_crua_por_forma),
        discos_camadas: Number(form.discos_camadas), discos_gramas: Number(form.discos_gramas),
        calda_camadas: Number(form.calda_camadas), calda_gramas: Number(form.calda_gramas),
        cinta_camadas: Number(form.cinta_camadas), cinta_gramas: Number(form.cinta_gramas),
        cobertura_camadas: Number(form.cobertura_camadas), cobertura_gramas: Number(form.cobertura_gramas),
        recheio_camadas: Number(form.recheio_camadas),
        massas: massesSelecionadas,
      };
      let tamanhoId;
      if (editando) {
        await api.put(`/guia/tamanhos/${editando}`, payloadTam);
        tamanhoId = editando;
      } else {
        const res = await api.post('/guia/tamanhos', payloadTam);
        tamanhoId = res.data.id;
      }

      // 2. Recheios + quantidades
      const recheiosNovos = recheiosSelecionados.filter(r => r.isNew);
      const recheiosExist = recheiosSelecionados.filter(r => !r.isNew);
      if (recheiosNovos.length) setSalvarMsg(`Criando ${recheiosNovos.length} recheio${recheiosNovos.length > 1 ? 's' : ''} novo${recheiosNovos.length > 1 ? 's' : ''}...`);
      else if (recheiosExist.length) setSalvarMsg(`Salvando quantidades dos recheios...`);

      const recheiosResolvidos = [];
      for (const [i, r] of recheiosSelecionados.entries()) {
        let recheioId = r.id;

        if (r.isNew) {
          setSalvarMsg(`Criando recheio "${r.nome}"... (${i + 1}/${recheiosSelecionados.length})`);
          const payload = {
            nome: r.nome,
            base_ficha_id: r.base_tipo === 'ficha' ? Number(r.base_ficha_id) || null : null,
            base_produto_id: r.base_tipo === 'produto' ? Number(r.base_produto_id) || null : null,
            complemento_ficha_id: r.tem_complemento && r.complemento_tipo === 'ficha' ? Number(r.complemento_ficha_id) || null : null,
            complemento_produto_id: r.tem_complemento && r.complemento_tipo === 'produto' ? Number(r.complemento_produto_id) || null : null,
          };
          const res = await api.post('/guia/recheios', payload);
          recheioId = res.data.id;
        }

        if (r.gramas_base) {
          setSalvarMsg(`Salvando quantidades de "${r.nome}"...`);
          await api.put(`/guia/recheios/${recheioId}/quantidades/${tamanhoId}`, {
            gramas_base: Number(r.gramas_base),
            gramas_complemento: r.gramas_complemento ? Number(r.gramas_complemento) : null,
          });
        }

        recheiosResolvidos.push({ ...r, resolvedId: recheioId });
      }

      // 3. Combinações
      if (combinacoes.length) {
        setSalvarMsg(`Salvando ${combinacoes.length} combinaç${combinacoes.length > 1 ? 'ões' : 'ão'}...`);
        for (const c of combinacoes) {
          const rA = recheiosResolvidos.find(r => chaveRecheio(r) === c.keyA);
          const rB = recheiosResolvidos.find(r => chaveRecheio(r) === c.keyB);
          if (!rA || !rB) continue;
          await api.post('/guia/combinacoes', {
            nome: c.nome,
            recheio_principal_id: rA.resolvedId,
            recheio_secundario_id: rB.resolvedId,
            camadas_principal: c.camadas_a,
            camadas_secundario: c.camadas_b,
          });
        }
      }

      setSalvarMsg('✓ Tudo salvo!');
      await new Promise(r => setTimeout(r, 600));
      setSucesso(editando ? 'Tamanho atualizado!' : 'Tamanho cadastrado com sucesso!');
      fecharWizard();
      carregarDados();
    } catch (e) {
      setErro(e.response?.data?.erro || 'Erro ao salvar');
    } finally {
      setSalvando(false);
      setSalvarMsg('');
    }
  }

  async function desativar(id) {
    if (!window.confirm('Desativar este tamanho?')) return;
    try {
      await api.delete(`/guia/tamanhos/${id}`);
      setSucesso('Tamanho desativado.');
      carregarDados();
    } catch {
      setErro('Erro ao desativar tamanho');
    }
  }

  // ── Filtros ──────────────────────────────────────────────────────────────────
  const tamanhosFiltrados = tamanhos.filter(t => {
    const matchBusca = !busca || t.nome.toLowerCase().includes(busca.toLowerCase());
    const matchTipo = tipoFiltro === 'todos' || t.tipo === tipoFiltro;
    return matchBusca && matchTipo;
  });
  const tamanhosImediatos = tamanhosFiltrados.filter(t => t.tipo === 'imediato');
  const tamanhosCongelados = tamanhosFiltrados.filter(t => t.tipo === 'congelado');

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <div className="p-6 max-w-6xl mx-auto">

      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-700">Tamanhos de Bolo</h1>
          <p className="text-gray-400 text-sm mt-1">Cadastro dos tamanhos, formas e padrões de montagem</p>
        </div>
        <button onClick={abrirNovo}
          className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2 text-sm">
          + Novo Tamanho
        </button>
      </div>

      {erro && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4 text-sm">{erro}</div>}
      {sucesso && <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-4 text-sm">{sucesso}</div>}

      {/* Filtros */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="relative">
          <span className="absolute left-3 top-2.5 text-gray-400 text-sm">🔍</span>
          <input
            type="text"
            placeholder="Buscar por nome..."
            value={busca}
            onChange={e => setBusca(e.target.value)}
            className="w-full pl-9 pr-9 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-pink-300 focus:border-transparent"
          />
          {busca && (
            <button onClick={() => setBusca('')}
              className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600 text-sm">✕</button>
          )}
        </div>
        <select
          value={tipoFiltro}
          onChange={e => setTipoFiltro(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-pink-300">
          <option value="todos">🎂 Todos os tipos</option>
          <option value="imediato">🕐 Imediatos</option>
          <option value="congelado">❄️ Congelados</option>
        </select>
      </div>

      {/* Filtros ativos */}
      {(busca || tipoFiltro !== 'todos') && (
        <div className="mb-4 flex items-center gap-2 flex-wrap">
          <span className="text-sm text-gray-500">Filtros ativos:</span>
          {busca && (
            <span className="bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-sm flex items-center gap-2">
              Busca: "{busca}"
              <span className="cursor-pointer hover:text-pink-900" onClick={() => setBusca('')}>✕</span>
            </span>
          )}
          {tipoFiltro !== 'todos' && (
            <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm flex items-center gap-2">
              {tipoFiltro === 'imediato' ? '🕐 Imediatos' : '❄️ Congelados'}
              <span className="cursor-pointer hover:text-blue-900" onClick={() => setTipoFiltro('todos')}>✕</span>
            </span>
          )}
          <button onClick={() => { setBusca(''); setTipoFiltro('todos'); }}
            className="text-sm text-red-500 hover:text-red-700 underline">Limpar todos</button>
        </div>
      )}

      {loading ? (
        <div className="text-center py-12 text-gray-400">Carregando...</div>
      ) : tamanhosFiltrados.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">Nenhum tamanho encontrado</p>
          <p className="text-gray-400 text-sm mt-2">
            {busca || tipoFiltro !== 'todos' ? 'Tente ajustar os filtros' : 'Clique em "+ Novo Tamanho" para começar'}
          </p>
        </div>
      ) : (
        <>
          {/* ── Imediatos ── */}
          {(tipoFiltro === 'todos' || tipoFiltro === 'imediato') && tamanhosImediatos.length > 0 && (
            <div className="mb-8">
              <h3 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm">
                  🕐 Imediatos ({tamanhosImediatos.length})
                </span>
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-medium text-gray-700">Nome</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Fatias</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Recheio</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Massa crua</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Forma</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Cakeboard</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700" style={{width:'90px'}}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tamanhosImediatos.map(t => (
                      <tr key={t.id} className="hover:bg-gray-50 transition-colors">
                        <td className="border border-gray-300 px-3 py-2 font-semibold text-gray-800">{t.nome}</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-600">{t.fatias}</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-600">{t.recheio_camadas} cam.</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-600">{t.massa_crua_por_forma}g</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-500">{t.forma_tamanho || '—'}</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-500">{t.cakeboard_tamanho || '—'}</td>
                        <td className="border border-gray-300 px-2 py-2">
                          <div className="flex items-center justify-center gap-1">
                            <button onClick={() => abrirEditar(t)}
                              className="bg-gray-500 text-white p-1.5 rounded hover:bg-gray-600 transition-colors" title="Editar">
                              ✏️
                            </button>
                            <button onClick={() => desativar(t.id)}
                              className="bg-red-500 text-white p-1.5 rounded hover:bg-red-600 transition-colors" title="Remover">
                              🗑️
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* ── Congelados ── */}
          {(tipoFiltro === 'todos' || tipoFiltro === 'congelado') && tamanhosCongelados.length > 0 && (
            <div className="mb-8">
              <h3 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
                  ❄️ Congelados ({tamanhosCongelados.length})
                </span>
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-3 py-2 text-left font-medium text-gray-700">Nome</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Fatias</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Recheio</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Massa crua</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Forma</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700">Cakeboard</th>
                      <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700" style={{width:'90px'}}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tamanhosCongelados.map(t => (
                      <tr key={t.id} className="hover:bg-blue-50/40 transition-colors">
                        <td className="border border-gray-300 px-3 py-2 font-semibold text-gray-800">{t.nome}</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-600">{t.fatias}</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-600">{t.recheio_camadas} cam.</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-600">{t.massa_crua_por_forma}g</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-500">{t.forma_tamanho || '—'}</td>
                        <td className="border border-gray-300 px-3 py-2 text-center text-gray-500">{t.cakeboard_tamanho || '—'}</td>
                        <td className="border border-gray-300 px-2 py-2">
                          <div className="flex items-center justify-center gap-1">
                            <button onClick={() => abrirEditar(t)}
                              className="bg-gray-500 text-white p-1.5 rounded hover:bg-gray-600 transition-colors" title="Editar">
                              ✏️
                            </button>
                            <button onClick={() => desativar(t.id)}
                              className="bg-red-500 text-white p-1.5 rounded hover:bg-red-600 transition-colors" title="Remover">
                              🗑️
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Rodapé */}
          <div className="mt-2 p-4 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center gap-3">
              <span className="font-medium text-gray-700 text-sm">
                Total: {tamanhosFiltrados.length} {tamanhosFiltrados.length === 1 ? 'tamanho' : 'tamanhos'}
              </span>
              <div className="flex gap-3">
                <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm font-medium">
                  🕐 {tamanhos.filter(t => t.tipo === 'imediato').length} Imediatos
                </span>
                <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                  ❄️ {tamanhos.filter(t => t.tipo === 'congelado').length} Congelados
                </span>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ═══════════════════════════ WIZARD ═══════════════════════════ */}
      {wizardAberto && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-start justify-center z-50 overflow-y-auto py-8">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-4">

            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h2 className="text-lg font-bold text-gray-800">
                {editando ? 'Editar Tamanho' : 'Novo Tamanho'}
              </h2>
              <button onClick={fecharWizard} className="text-gray-400 hover:text-gray-600 text-xl font-bold">×</button>
            </div>

            <div className="px-6 pt-5 pb-1">
              <Progresso step={step} total={totalSteps} />
            </div>

            <div className="px-6 pb-4 max-h-[65vh] overflow-y-auto">

              {/* ── Step 1: Dados básicos ── */}
              {step === 1 && (
                <div className="space-y-4">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Identificação</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { label: 'Nome *', name: 'nome', type: 'text', placeholder: 'ex: 15cm' },
                      { label: 'Fatias *', name: 'fatias', type: 'number', placeholder: '18' },
                      { label: 'Tamanho da forma', name: 'forma_tamanho', type: 'text', placeholder: 'ex: 15cm' },
                      { label: 'Cakeboard', name: 'cakeboard_tamanho', type: 'text', placeholder: 'ex: 18cm' },
                    ].map(f => (
                      <div key={f.name}>
                        <label className="block text-sm font-medium text-gray-700 mb-1">{f.label}</label>
                        <input name={f.name} type={f.type} value={form[f.name]} onChange={handleChange}
                          placeholder={f.placeholder}
                          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                      </div>
                    ))}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Tipo *</label>
                      <select name="tipo" value={form.tipo} onChange={handleChange}
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                        <option value="imediato">🕐 Imediato</option>
                        <option value="congelado">❄️ Congelado</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Camadas de recheio *</label>
                      <select name="recheio_camadas" value={form.recheio_camadas} onChange={handleChange}
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                        <option value="2">2 camadas</option>
                        <option value="3">3 camadas</option>
                        <option value="4">4 camadas</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Massa crua por forma (g) *</label>
                      <input name="massa_crua_por_forma" type="number" value={form.massa_crua_por_forma}
                        onChange={handleChange} placeholder="420"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Discos por forma *</label>
                      <input name="discos_por_forma" type="number" min="1" value={form.discos_por_forma}
                        onChange={handleChange} placeholder="2"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                    </div>
                  </div>

                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider pt-2">Componentes de montagem</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { label: 'Discos', c: 'discos_camadas', g: 'discos_gramas' },
                      { label: 'Calda', c: 'calda_camadas', g: 'calda_gramas' },
                      { label: 'Cinta', c: 'cinta_camadas', g: 'cinta_gramas' },
                      { label: 'Cobertura', c: 'cobertura_camadas', g: 'cobertura_gramas' },
                    ].map(comp => (
                      <div key={comp.label} className="bg-gray-50 rounded-lg p-3">
                        <p className="text-xs font-semibold text-gray-500 mb-2">{comp.label}</p>
                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <label className="block text-xs text-gray-500 mb-1">Camadas</label>
                            <input name={comp.c} type="number" value={form[comp.c]} onChange={handleChange}
                              className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-500 mb-1">g/camada</label>
                            <input name={comp.g} type="number" value={form[comp.g]} onChange={handleChange}
                              className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                          </div>
                        </div>
                        {form[comp.c] && form[comp.g] && (
                          <p className="text-xs text-pink-600 mt-1">Total: {Number(form[comp.c]) * Number(form[comp.g])}g</p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ── Step 2: Massas ── */}
              {step === 2 && (
                <div>
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Sabores de massa permitidos</h3>
                  <p className="text-sm text-gray-500 mb-4">Quais massas podem ser usadas no tamanho <strong>{form.nome}</strong>?</p>
                  {fichasMassa.length === 0 ? (
                    <p className="text-sm text-gray-400">Nenhuma ficha de massa cadastrada.</p>
                  ) : (
                    <div className="flex flex-wrap gap-2">
                      {fichasMassa.map(f => (
                        <button key={f.id} type="button"
                          onClick={() => setMassesSelecionadas(p =>
                            p.includes(f.id) ? p.filter(id => id !== f.id) : [...p, f.id]
                          )}
                          className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
                            massesSelecionadas.includes(f.id)
                              ? 'bg-pink-600 text-white border-pink-600'
                              : 'bg-white text-gray-600 border-gray-200 hover:border-pink-300'
                          }`}>
                          {f.nome}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* ── Step 3: Recheios ── */}
              {step === 3 && (
                <div className="space-y-4">
                  <div>
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Recheios disponíveis para {form.nome}</h3>
                    <p className="text-sm text-gray-500 mb-3">
                      Selecione os recheios do menu e defina as gramas por camada para este tamanho.
                      {nCamadas === 3 && ' As combinações serão configuradas no próximo passo.'}
                    </p>

                    {/* Recheios já cadastrados */}
                    {recheiosExistentes.length > 0 && (
                      <div className="mb-4">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-xs text-gray-400">
                            {recheiosSelecionados.filter(r => !r.isNew).length}/{recheiosExistentes.length} selecionados
                          </span>
                          <div className="flex gap-3">
                            <button type="button"
                              onClick={() => {
                                recheiosExistentes.forEach(r => {
                                  if (!recheiosSelecionados.find(x => x.id === r.id)) toggleRecheioExistente(r);
                                });
                              }}
                              className="text-xs text-pink-600 hover:text-pink-800 font-medium">
                              Selecionar todos
                            </button>
                            <button type="button"
                              onClick={() => setRecheiosSelecionados(p => p.filter(r => r.isNew))}
                              className="text-xs text-gray-400 hover:text-gray-600 font-medium">
                              Limpar
                            </button>
                          </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {recheiosExistentes.map(r => {
                            const sel = recheiosSelecionados.find(x => x.id === r.id);
                            return (
                              <button key={r.id} type="button" onClick={() => toggleRecheioExistente(r)}
                                className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
                                  sel ? 'bg-pink-600 text-white border-pink-600' : 'bg-white text-gray-600 border-gray-200 hover:border-pink-300'
                                }`}>
                                {r.nome}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Cards dos recheios selecionados */}
                  {recheiosSelecionados.length > 0 && (
                    <div className="space-y-3">
                      {recheiosSelecionados.map(r => {
                        const key = chaveRecheio(r);
                        const recheioBase = !r.isNew ? recheiosExistentes.find(x => x.id === r.id) : null;
                        const mostrarCompl = r.isNew ? r.tem_complemento : !!(recheioBase?.complemento_ficha_id || recheioBase?.complemento_produto_id);
                        return (
                          <div key={key} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                            <div className="flex items-center justify-between mb-3">
                              {r.isNew ? (
                                <input value={r.nome}
                                  onChange={e => atualizarRecheio(key, 'nome', e.target.value)}
                                  placeholder="Nome do recheio"
                                  className="font-medium text-gray-700 text-sm bg-transparent border-b border-gray-300 focus:outline-none focus:border-pink-400 flex-1 mr-2" />
                              ) : (
                                <span className="font-medium text-gray-700 text-sm">{r.nome}</span>
                              )}
                              <button type="button" onClick={() => removerRecheio(key)}
                                className="text-gray-300 hover:text-red-400 text-xl leading-none">×</button>
                            </div>

                            {/* Novo recheio: definir base */}
                            {r.isNew && (
                              <div className="space-y-3 mb-3 pb-3 border-b border-gray-200">
                                <div>
                                  <label className="text-xs text-gray-500 font-medium mb-1.5 block">Base *</label>
                                  <div className="flex gap-2 mb-2">
                                    {[['ficha', '📋 Ficha técnica'], ['produto', '📦 Produto']].map(([t, l]) => (
                                      <button key={t} type="button" onClick={() => atualizarRecheio(key, 'base_tipo', t)}
                                        className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
                                          r.base_tipo === t ? 'bg-gray-700 text-white border-gray-700' : 'border-gray-200 text-gray-500 hover:border-gray-400'
                                        }`}>{l}</button>
                                    ))}
                                  </div>
                                  {r.base_tipo === 'ficha' ? (
                                    <select value={r.base_ficha_id} onChange={e => atualizarRecheio(key, 'base_ficha_id', e.target.value)}
                                      className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                                      <option value="">Selecione a ficha...</option>
                                      {todasFichas.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                                    </select>
                                  ) : (
                                    <select value={r.base_produto_id} onChange={e => atualizarRecheio(key, 'base_produto_id', e.target.value)}
                                      className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                                      <option value="">Selecione o produto...</option>
                                      {produtos.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                                    </select>
                                  )}
                                </div>

                                <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer select-none">
                                  <input type="checkbox" checked={r.tem_complemento}
                                    onChange={e => atualizarRecheio(key, 'tem_complemento', e.target.checked)}
                                    className="accent-pink-600 w-4 h-4" />
                                  Tem complemento?
                                </label>

                                {r.tem_complemento && (
                                  <div>
                                    <label className="text-xs text-gray-500 font-medium mb-1.5 block">Complemento</label>
                                    <div className="flex gap-2 mb-2">
                                      {[['ficha', '📋 Ficha técnica'], ['produto', '📦 Produto']].map(([t, l]) => (
                                        <button key={t} type="button" onClick={() => atualizarRecheio(key, 'complemento_tipo', t)}
                                          className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
                                            r.complemento_tipo === t ? 'bg-gray-700 text-white border-gray-700' : 'border-gray-200 text-gray-500 hover:border-gray-400'
                                          }`}>{l}</button>
                                      ))}
                                    </div>
                                    {r.complemento_tipo === 'ficha' ? (
                                      <select value={r.complemento_ficha_id} onChange={e => atualizarRecheio(key, 'complemento_ficha_id', e.target.value)}
                                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                                        <option value="">Selecione o complemento...</option>
                                        {todasFichas.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                                      </select>
                                    ) : (
                                      <select value={r.complemento_produto_id} onChange={e => atualizarRecheio(key, 'complemento_produto_id', e.target.value)}
                                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                                        <option value="">Selecione o produto...</option>
                                        {produtos.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                                      </select>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Gramas por camada */}
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <label className="block text-xs text-gray-500 mb-1">Base — g/camada *</label>
                                <input type="number" value={r.gramas_base}
                                  onChange={e => atualizarRecheio(key, 'gramas_base', e.target.value)}
                                  placeholder="140"
                                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                              </div>
                              {mostrarCompl && (
                                <div>
                                  <label className="block text-xs text-gray-500 mb-1">Complemento — g/camada</label>
                                  <input type="number" value={r.gramas_complemento}
                                    onChange={e => atualizarRecheio(key, 'gramas_complemento', e.target.value)}
                                    placeholder="60"
                                    className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  <button type="button" onClick={adicionarNovoRecheio}
                    className="w-full py-2.5 border-2 border-dashed border-gray-200 rounded-xl text-sm text-gray-400 hover:border-pink-300 hover:text-pink-500 transition-colors font-medium">
                    + Cadastrar novo recheio
                  </button>
                </div>
              )}

              {/* ── Step 4: Combinações ── */}
              {step === 4 && (
                <div className="space-y-4">
                  <div>
                    <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Distribuição das {nCamadas} camadas</h3>
                    <p className="text-sm text-gray-500 mb-4">
                      Para cada par de recheios, defina como as {nCamadas} camadas se distribuem.
                    </p>
                  </div>
                  {combinacoes.map(c => (
                    <div key={c.key} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="bg-pink-100 text-pink-700 px-2.5 py-0.5 rounded-full text-xs font-semibold">{c.nomeA}</span>
                        <span className="text-gray-300 text-sm">+</span>
                        <span className="bg-purple-100 text-purple-700 px-2.5 py-0.5 rounded-full text-xs font-semibold">{c.nomeB}</span>
                      </div>

                      <div className="flex items-end gap-3 mb-3">
                        <div className="flex-1">
                          <label className="text-xs text-gray-500 mb-1 block">Camadas de {c.nomeA}</label>
                          <select value={c.camadas_a}
                            onChange={e => atualizarCombinacao(c.key, 'camadas_a', e.target.value)}
                            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                            {Array.from({ length: nCamadas - 1 }, (_, i) => i + 1).map(n => (
                              <option key={n} value={n}>{n} camada{n > 1 ? 's' : ''}</option>
                            ))}
                          </select>
                        </div>
                        <span className="text-gray-400 text-sm pb-2">+</span>
                        <div className="flex-1">
                          <label className="text-xs text-gray-500 mb-1 block">Camadas de {c.nomeB}</label>
                          <div className="border border-gray-100 bg-white rounded-lg px-3 py-2 text-sm text-gray-400">
                            {c.camadas_b} camada{c.camadas_b !== 1 ? 's' : ''}
                          </div>
                        </div>
                        <span className="text-gray-400 text-sm pb-2">= {nCamadas}</span>
                      </div>

                      {/* Preview visual */}
                      <div className="flex gap-1 mb-3">
                        {[...Array(c.camadas_a)].map((_, i) => (
                          <span key={`a${i}`} className="bg-pink-100 text-pink-700 text-xs px-2 py-0.5 rounded font-medium">{c.nomeA}</span>
                        ))}
                        {[...Array(c.camadas_b)].map((_, i) => (
                          <span key={`b${i}`} className="bg-purple-100 text-purple-700 text-xs px-2 py-0.5 rounded font-medium">{c.nomeB}</span>
                        ))}
                      </div>

                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Nome da combinação</label>
                        <input value={c.nome}
                          onChange={e => setCombinacoes(p => p.map(cc => cc.key === c.key ? { ...cc, nome: e.target.value } : cc))}
                          className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300" />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100">
              <button type="button"
                onClick={() => step > 1 ? setStep(s => s - 1) : fecharWizard()}
                className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 font-medium"
                disabled={salvando}>
                {step > 1 ? '← Voltar' : 'Cancelar'}
              </button>

              {salvando ? (
                <div className="flex items-center gap-2 text-sm text-pink-600">
                  <span className="inline-block w-4 h-4 border-2 border-pink-400 border-t-transparent rounded-full animate-spin"></span>
                  <span>{salvarMsg}</span>
                </div>
              ) : isLastStep ? (
                <button type="button" onClick={salvar} disabled={salvando}
                  className="bg-pink-600 hover:bg-pink-700 disabled:opacity-60 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors">
                  ✓ Salvar tudo
                </button>
              ) : (
                <button type="button" onClick={avancar}
                  disabled={step === 1 && !step1Valido()}
                  className="bg-pink-600 hover:bg-pink-700 disabled:opacity-50 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors">
                  Próximo →
                </button>
              )}
            </div>

          </div>
        </div>
      )}
    </div>
  );
}